import * as React from "react";
import {Paper, Box, Stack, Typography} from "@mui/material";
import {styled} from "@mui/material/styles";
import {removeHtml, truncateStr} from "../Service";
import {useDarkMode} from "../darkMode/hook/useDarkMode";

const Img = styled('img')({
    top: '33px',
    left: '34px',
    display: 'block',
    width: '464px',
    height: 'auto',
    borderRadius: '5px'
});

const AdviceDescriptionCard = ({advice}) => {
    const {mode} = useDarkMode();
    return (
        <Paper id={'advice-description__card'} style={{backgroundColor: mode.settings.cardBackgroundColor}}>
            <Stack
                direction="column"
                justifyContent="left"
                alignItems="flex-start"
                spacing={2}
                sx={{padding:{xs : '0px', md : '0px', lg : '16px'}}}
            >
                <Stack
                    direction="row"
                    justifyContent="left"
                    alignItems="flex-start"
                    spacing={{xs : 0, md : 0, lg : 2}}
                    flexWrap={"wrap"}
                    gap={2}
                    width={'100%'}
                >
                    <Box sx={{width : {xs : '100%', md : '100%', lg : '44%'}}}>
                        <Img
                            style={{width : '-webkit-fill-available', padding : '15px'}}
                            alt={'Image conseil'}
                            src={`/assets/img/advice3.png`}
                            role="img"
                        />
                    </Box>
                    <Stack
                        direction="column"
                        justifyContent="left"
                        alignItems="flex-start"
                        spacing={{xs : 0, md : 0, lg : 3}}
                        sx={{width : '100%', maxWidth : {lg : '49%'}, padding : '15px'}}
                    >
                        <Typography variant="h3" sx={{color:'#DD809D'}}>
                            Description
                        </Typography>
                        <Typography
                            variant={'subtitle3'}
                            sx={{marginLeft:'2px !important'}}
                            style={{color : mode.settings.textColor3}}
                        >
                            <div dangerouslySetInnerHTML={{ __html: advice.description }} />
                        </Typography>
                    </Stack>
                </Stack>
            </Stack>
        </Paper>
    )
}

export default AdviceDescriptionCard;
